import { OrganizationScope } from "~/hooks/useScope";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Home as HomeIcon } from "@mui/icons-material";
import { PoliciesAddPage } from "~/pages/shared/policy/PoliciesAddPage";

export interface OrganizationPoliciesAddPageProps {
  scope: OrganizationScope;
}

export function OrganizationPoliciesAddPage({
  scope,
}: OrganizationPoliciesAddPageProps) {
  const breadcrumbs = (
    <Breadcrumbs sx={{ mb: 3, overflowWrap: "anywhere" }} separator="›">
      <Link
        key="/dashboard"
        component={RouterLink}
        to={`/dashboard`}
        display="flex"
      >
        <HomeIcon fontSize="inherit" />
      </Link>
      <Link
        key="/organization/policies"
        component={RouterLink}
        to={`/organization/policies?${scope.params}`}
      >
        Organization Policies
      </Link>
      <Typography key="/organization/policies/add">Add Policies</Typography>
    </Breadcrumbs>
  );

  return (
    <PoliciesAddPage
      scope={scope}
      basePath="/organization/policies"
      sectionLabel="Organization Policies"
      breadcrumbs={breadcrumbs}
    />
  );
}
